// extracted by mini-css-extract-plugin
export default {"formFrame":"typeform_formFrame__i8lgS","SkipButton":"typeform_SkipButton__5S18i"};